// @flow

export const PP_ACCEPTED = '1';
export const EXCLUSIVITY = '32';
export const PETS_ALLOWED = '9';
export const FREE_CANCELLATION = '49';
